import React from 'react';
import PropTypes from 'prop-types';
import MaterialModal from '@material-ui/core/Modal';

import useStyles from './useStyles';

const Modal = ({ showModal, setShowModal, children }) => {
  const classes = useStyles();
  return (
    <MaterialModal
      open={showModal}
      onClose={setShowModal}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div
        className={classes.container}
      >
        {children}
      </div>
    </MaterialModal>
  );
};

Modal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export default Modal;
